import React from 'react'
import ProfileNav from '../Components/Navbar/ProfileNav'
import { useState } from 'react'
import ProfileTab from '../Components/SerTab/ProfileTab';
import OrdersTab from '../Components/SerTab/OrdersTab';
import ProductsTab from '../Components/SerTab/ProductsTab';
import YourOrders from '../Components/SerTab/YourOrders';
import { useContext } from 'react';
import { LoginContext } from '../AuthContext/LoginContext';

const Profile = () => {
  const [section,setSection]=useState(1);
  const {islogin}=useContext(LoginContext);
  const setter=(num)=>{
    console.log(num);
    setSection(num);
  }
  console.log(islogin)
  return (
    <div>
      {
        islogin?
        <div>
          <ProfileNav setter={setter}/>
          {
            section===1?
            <ProfileTab/>
            :
            section===2?
            <OrdersTab/>
            :
            section===3?
            <ProductsTab/>
            :
            <YourOrders/>
          }
        </div>
        :
        <div className='text-red-500 text-9xl'>
          NOT LOGGED IN
        </div>
      }
    </div>
  )
}

export default Profile